import axios from "axios";

// Send httpOnly cookies with every request (auth tokens)
axios.defaults.withCredentials = true;
